module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_stethscope-e49ede013e3fe26de9f318d987771b00.svg";